// TaskSubtaskProgressBar.jsx: edge-progress for master-view parents.
// Geen MUI LinearProgress — te zwaar en past niet in 2px edge-slot.
import { useMemo } from 'react';
import { translate as t } from '@/i18n/useT';
import { useTasksContext } from '@/features/tasks/context/TasksContext.def';
import { computeSubtaskProgress } from '@/features/tasks/utils/structure/taskRollupUtils';

/**
 * @param {{ task: object, displayDuration: number }} props
 */
export const TaskSubtaskProgressBar = ({ task, displayDuration }) => {
  const { taskTree } = useTasksContext();
  const progress = useMemo(
    () => computeSubtaskProgress(task, taskTree, displayDuration),
    [task, taskTree, displayDuration],
  );

  if (!progress) return null;

  const label = `${progress.completed}/${progress.total} ${t('taskexecutionactions.subtaskProgress', 'subtasks completed')}`;
  const isComplete = progress.percent === 100;

  return (
    <div
      className={`task-item__subtask-progress${isComplete ? ' task-item__subtask-progress--complete' : ''}`}
      role="progressbar"
      aria-valuenow={progress.percent}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
      title={label}
    >
      <div
        className="task-item__subtask-progress-fill"
        style={{ width: `${progress.percent}%` }}
      />
    </div>
  );
};
